import {
  findReceiptFromAccountingSession,
  downloadReceiptPdf,
} from "../../Classes/API/ReceiptsApi";
import Swal from "sweetalert2";

export const handlePrintReceipt = async (sessionId) => {
  if (!sessionId) {
    console.error("No Session ID provided for receipt download.");
    return;
  }

  Swal.fire({
    title: "Generating Receipt...",
    allowOutsideClick: false,
    didOpen: () => {
      Swal.showLoading();
    },
  });

  try {
    const receiptData = await findReceiptFromAccountingSession(sessionId);

    if (!receiptData || !receiptData.id) {
      throw new Error("Receipt record not found.");
    }

    const blob = await downloadReceiptPdf(receiptData.id);
    const downloadUrl = window.URL.createObjectURL(blob);
    const link = document.createElement("a");
    link.href = downloadUrl;
    link.setAttribute("download", `Receipt_${receiptData.id}.pdf`);

    document.body.appendChild(link);
    link.click();
    link.remove();
    window.URL.revokeObjectURL(downloadUrl);

    Swal.close();
  } catch (error) {
    console.error("Print Receipt Error:", error);
    Swal.fire({
      title: "Print Error",
      text: "Failed to download the receipt. Please try again.",
      icon: "error",
      confirmButtonText: "Ok",
    });
  }
};
